import { Dialog, Toast, ImageUploader } from "antd-mobile";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import $ from "jquery";
import PsContext from "../../context";
import {
  groupByMultiple,
  momentDate,
  semesterValue,
  sleep,
  jsonToQuery,
  getFileLiveUrl,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Image, List } from "antd-mobile";
import { FileTextOutlined } from "@ant-design/icons";
import { CommentOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { FloatButton, Switch, message, Form, Input, Spin, Tag } from "antd";
import ModuleAccess from "../../context/moduleAccess";
import FileBrowserModal from "../../app/fileManager";
import ReactFileReader from "react-file-reader";
import { SELECT_USER_PHOTO } from "../../utils/data";
import { baseUrl } from "../../utils";

const ViewService = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    setViewData(props.requestItem);
  }, [props.requestItem]);
  console.log(props.requestItem.id);
  const isOnlinePayment = () => {
    var payModes = props.requestType.payment_modes.split(",");
    if (payModes.includes("online")) return true;
    else return false;
  };
  const handlePayClick = () => {
    setLoader(true);
    var form = new FormData();
    form.append("service_request_id", props.requestItem.id);
    form.append("amount", props.requestType.service_cost);
    axios.post(ServiceUrl.REQUEST.ADD_REQUEST_PAYMENT, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({ content: res["data"].message || "Saved" });

        window.location.replace( baseUrl + "mob/stu/v1/srequest_payment/make-srequest-payment/" + res["data"].data);
        setLoader(false);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
        setLoader(false);
      }
    });
  };
  const handleRefreshClick = () => {
    setLoader(true);
    setDataList([]);
    const form = new FormData();
    form.append("service_request_id", props.requestItem.id);
    axios.post(ServiceUrl.REQUEST.LIST_REQUEST_PAYMENT, form).then((res) => {
      if (res["data"].status == "1") {
        console.log(res["data"].data);
        setDataList(res["data"].data);
        props.onSuccess();
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Spin spinning={loader}>
        <div>
          {viewData && (
            <>
              <Card>
                <Card.Header onClick={(e) => props.onHide()}></Card.Header>
                <Card.Body>
                  <table
                    width="100%"
                    align="center"
                    className="font-bookman"
                    cellPadding={3}
                  >
                    <thead>
                      <tr align="center">
                        <th colSpan={3} align="center" height="30">
                          {viewData &&
                            isOnlinePayment() &&
                            (viewData.pay_status === "paid" ||
                              viewData.pay_status === "shipped") && (
                              <Tag color="green">Paid</Tag>
                            )}
                          {viewData &&
                            isOnlinePayment() &&
                            viewData.pay_status !== "paid" &&
                            viewData.pay_status !== "shipped" && (
                              <Tag color="red">Unpaid</Tag>
                            )}
                          {viewData &&
                            isOnlinePayment() &&
                            viewData.pay_status !== "paid" &&
                            viewData.pay_status !== "shipped" && (
                              <Tag
                                color="green"
                                onClick={handlePayClick}
                                style={{ cursor: "pointer" }}
                              >
                                Pay
                              </Tag>
                            )}
                          {/* {viewData &&
                            isOnlinePayment() &&
                            viewData.pay_status !== "paid" &&
                            viewData.pay_status !== "shipped" && (
                              <Tag
                                color="orange"
                                onClick={handleRefreshClick}
                                style={{ cursor: "pointer" }}
                              >
                                Refresh
                              </Tag>
                            )} */}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="30%">Status</td>
                        <td align="center" width="10%">
                          :
                        </td>
                        <td width="70%">{viewData.request_status}</td>
                      </tr>
                      <tr>
                        <td colSpan={3} width="30%">
                          {" "}
                          {viewData.description}{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
            </>
          )}
        </div>
      </Spin>
    </>
  );
};
export default ViewService;
